import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useOnboarding } from '../OnboardingContext';

export default function StepEmail({ onNext }) {
  const { state, setField } = useOnboarding();
  const [email, setEmail] = useState(state.ownerEmail || '');
  const [firstName, setFirstName] = useState(state.ownerFirstName || '');
  const [lastName, setLastName] = useState(state.ownerLastName || '');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleNext = async () => {
    setError('');
    setLoading(true);
    try {
  const normalized = (email || '').trim().toLowerCase();
  const f = (firstName || '').trim();
  const l = (lastName || '').trim();
  setField('ownerEmail', normalized);
  setField('ownerFirstName', f || null);
  setField('ownerLastName', l || null);
  // Save a local fallback so unauthenticated users don't lose progress
  try { localStorage.setItem('onboardingDraft', JSON.stringify({ ...(state || {}), ownerEmail: normalized })); } catch (e) {}
  // eslint-disable-next-line no-console
  if (process.env.NODE_ENV !== 'production') console.info('[onboarding] ownerEmail set to', normalized);
      // Always require the signup step (password creation) before proceeding.
      if (typeof onNext === 'function') {
        try { onNext(); } catch (e) { console.warn('onNext threw, falling back to navigate:', e); }
      }
  // require basic name fields too
  navigate('/onboarding/signup');
    } catch (err) {
      console.error('Failed to advance onboarding from email step:', err);
      setError('Unable to continue — please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{padding:24}}>
      <h3>What's your email?</h3>
      <p>We'll use this to link your account and avoid duplicate workspaces.</p>
      <div style={{ display: 'grid', gap: 8, maxWidth: 520 }}>
        <input
          aria-label="owner-first-name"
          type="text"
          placeholder="First name"
          value={firstName}
          onChange={(e) => setFirstName(e.target.value)}
          style={{ padding: '10px 12px', borderRadius: 8, border: '1px solid #d6dbe5' }}
        />
        <input
          aria-label="owner-last-name"
          type="text"
          placeholder="Last name"
          value={lastName}
          onChange={(e) => setLastName(e.target.value)}
          style={{ padding: '10px 12px', borderRadius: 8, border: '1px solid #d6dbe5' }}
        />
        <input
          aria-label="owner-email"
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          style={{ padding: '10px 12px', borderRadius: 8, border: '1px solid #d6dbe5' }}
        />
      </div>
      {error && <div style={{ color: 'red', marginTop: 8 }}>{error}</div>}
      <div style={{ marginTop: 12, color: '#666' }}>
        Draft ownerEmail: <strong>{state.ownerEmail || '(not saved)'}</strong>
      </div>
      <div style={{marginTop:12}}>
        <button onClick={handleNext} disabled={!email || !firstName || !lastName || loading}>{loading ? 'Saving…' : 'Next'}</button>
      </div>
    </div>
  );
}
